module.exports = __webpack_public_path__ + "img-drag.png?717e88ea231147528bf2adc7859df214";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-drag.png
// module id = 923
// module chunks = 0